import React from "react";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import initStore from "./store";
import "./styles/App.css";
import Routes from "./router/Routes";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

export const store = initStore();

function App() {
  return (
    <Provider store={store.store}>
      <PersistGate loading={null} persistor={store.persistor}>
        <Routes />
        <ToastContainer autoClose={1000} />
      </PersistGate>
    </Provider>
  );
}

export default App;
